import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';
import { fg } from '@atlaskit/platform-feature-flags';

import { filterCommonAttributes } from './analytics-helpers';
import type { commonAttributesType } from './types';

// When there is no ai generated answer to the question
export const onAIAnswerNotShown: ({
	isStreamed,
	loadTime,
	fmpLoadTime,
	...props
}: commonAttributesType & {
	isStreamed: boolean;
	loadTime?: number;
	fmpLoadTime?: number;
}) => AnalyticsEventPayload = ({
	isStreamed,
	loadTime,
	fmpLoadTime,
	...props
}: commonAttributesType & {
	isStreamed: boolean;
	loadTime?: number;
	fmpLoadTime?: number;
}): AnalyticsEventPayload => {
	const {
		query,
		answerString,
		source,
		errorState,
		errorCode,
		networkErrorReason,
		networkErrorDetails,
		backendFailureType,
		streamEventsReceived,
		networkErrorDuration,
		extraAttributes,
	} = props;
	return {
		action: 'shown',
		actionSubject: 'aiAnswerError',
		source: source,
		eventType: 'track',
		attributes: {
			...filterCommonAttributes(props),
			isStreamed,
			loadTime,
			fmpLoadTime,
			errorState,
			...(fg('kd_granular_network_errors') && {
				errorCode,
				networkErrorReason,
				networkErrorDetails,
				traceId: extraAttributes?.requestId,
				backendFailureType,
				streamEventsReceived,
				networkErrorDuration,
			}),
		},
		nonPrivacySafeAttributes: {
			query,
			answerString,
		},
	};
};
